import { ServiceStoreConfig } from "../types/ServiceStoreTypes";

/**
 * AI Module Service Stores
 */
export const aiStores: ServiceStoreConfig[] = [
  // The "openai" store served only the legacy in-app AI Agent chat (deleted from
  // views/administration/AIAgent). AI chat now lives in @intrasync/ai-agent's
  // AgentHub — see serviceStores/aiAgent.stores.ts.
  // Note: Chat, chat-messages, and conversation-threads moved to communication.stores.ts
];